import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
declare var toastr;

@Component({
  selector: 'app-config-gestion',
  templateUrl: './config-gestion.component.html',
  styleUrls: [],
  providers: [GeneralService]
})
export class ConfigGestionComponent implements OnInit {
  gestiones: any = [];

  constructor(private router: Router, private _gs: GeneralService) {
    this._gs.getGestionesCombo().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.gestiones = result.data; }
        else { this.gestiones = []; }
      },
      (error) => { console.log('Error', error); });
  }

  ngOnInit() {
  }

  aplicarGestion(gestion: any) {
    if (gestion) {
      let m = { "gestion_id": gestion, "user_id": 10 };
      let g = this.gestiones.filter(o => o.id == gestion).map(o => o.gestion).toString();
      this._gs.postUsuarioGestion(m).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            localStorage.removeItem('g');
            localStorage.setItem('g', g);
            toastr.success('Modificación de gestión de trabajo exitoso, la gestión actual es ' + g + '.');
            //setTimeout(() => { this.router.navigate(['']); }, 500);
            setTimeout(() => { window.location.href = '/'; }, 600);
          }
        },
        error => { console.log('Error', error); });
    }
    else {
      toastr.warning('Seleccione una gestión.');
    }
  }
}
